/**
 * Date key helpers
 *
 * Small, dependency-free (feature-agnostic) helpers for converting dates into
 * stable local YYYY-MM-DD keys. Lives in shared so presentational components
 * can use it without importing a feature.
 *
 * @module shared/lib/dateKeys
 */

import { format } from 'date-fns';

/**
 * Convert a date (or ISO string) into a local YYYY-MM-DD key.
 *
 * Uses the local timezone so calendar-day comparisons behave intuitively for
 * the user (e.g. an event at 22:00 UTC shows on the correct local day).
 */
export function toLocalDateKey(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return format(date, 'yyyy-MM-dd');
}
